function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { THUMBNAILS_TYPES } from "/constants/thumbnails-types";
import BackgroundColorThumbnailItemComponent from "../background-color-thumbnail-item/background-color-thumbnail-item-component";
import BackgroundImageThumbnailItemComponent from "../background-image-thumbnail-item/background-image-thumbnail-item-component";
const THUMBNAILS_TYPE_TO_COMPONENT_MAPPING = {
    [THUMBNAILS_TYPES.BACKGROUND_COLOR]: BackgroundColorThumbnailItemComponent,
    [THUMBNAILS_TYPES.BACKGROUND_IMAGE]: BackgroundImageThumbnailItemComponent
};
class BaseThumbnailItemComponent extends PureComponent {
    mapThumbnailTypeToComponent() {
        const { thumbnailType } = this.props;
        return THUMBNAILS_TYPE_TO_COMPONENT_MAPPING[thumbnailType];
    }
    render() {
        const ThumbnailComponent = this.mapThumbnailTypeToComponent();
        return /*#__PURE__*/ _jsx(ThumbnailComponent, _object_spread({}, this.props));
    }
}
export { BaseThumbnailItemComponent as default };
BaseThumbnailItemComponent.defaultProps = {
    thumbnailType: THUMBNAILS_TYPES.BACKGROUND_COLOR
};
